export const customerReviews = [
    {
      "name": "Yogesh Choudhary",
      "location": "Rajasthan, India",
      "message": "Harmony transformed my healthcare experience! The online consultations were so convenient, and the doctors were knowledgeable and caring."
    },
    {
      "name": "Kundan Tamsoy",
      "location": "Jharkhand, India",
      "message": "I found the perfect specialist for my condition through Harmony. The personalized treatment plan made all the difference. Thank you for prioritizing my health!"
    },
    {
      "name": "Yash Goyal",
      "location": "Rajasthan, India",
      "message": "Booking appointments was a breeze, and the service exceeded my expectations. The doctors truly listen and provide effective solutions. 5 stars!"
    },
    {
      "name": "Ayush Kamboj",
      "location": "UP, India",
      "message": "Harmony is a game-changer! The emergency care saved me during a critical situation. Grateful for their quick and efficient support."
    },
    {
      "name": "Yash Sharma",
      "location": "Haryana, India",
      "message": "I used to dread dental visits, but Harmony made it a pleasant experience. The dentist was gentle and professional. I'll definitely be back!"
    },
    {
      "name": "Rakshit Kamboj",
      "location": "Haryana, India",
      "message": "Finally, a healthcare platform that puts patients first! The heart disease service provided comprehensive care and regular follow-ups. Thank you, Harmony!"
    },
    {
      "name": "Saikat Hazra",
      "location": "Bengal, India",
      "message": "I've been using Harmony for a variety of health concerns, and each time, I received exceptional care. It's my go-to for all medical needs!"
    },
    {
      "name": "Aditya Sharma",
      "location": "Haryana, India",
      "message": "I highly recommend Harmony for online consultations. It's convenient, secure, and the doctors are top-notch. Great job, team!"
    },
    {
      "name": "Yakshit Singla",
      "location": "Punjab, India",
      "message": "The convenience of accessing medical notes online was fantastic. Harmony made managing my health records hassle-free! Best Healthcare services."
    },
    {
      "name": "Aman Sharma",
      "location": "Himachal Pradesh, India",
      "message": "As a busy professional, Harmony has been a lifesaver. Quick prescriptions and refills without compromising on quality care. Thank you!"
    }
];
